import TherapistPublicProfilePage, {
  therapistProfileGetStaticPaths,
  therapistProfileGetStaticProps,
} from '@/legacy-src/components/TherapistPublicProfilePage'
import { getPublicTherapistSlugForLocale, PUBLIC_THERAPISTS_PAGE_SLUG } from '@/legacy-src/constants/locale.constants'

const PAGE_LOCALE = 'lt'

const CURRENT_SLUG = getPublicTherapistSlugForLocale(PAGE_LOCALE)

const Page = TherapistPublicProfilePage

const isPathValidForLocale = PUBLIC_THERAPISTS_PAGE_SLUG === CURRENT_SLUG

export const getStaticProps = therapistProfileGetStaticProps(isPathValidForLocale)
export const getStaticPaths = isPathValidForLocale
  ? therapistProfileGetStaticPaths
  : () => ({ paths: [], fallback: false })

export default Page
